(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-list"] && !Shopify.designMode) return;
  try {
    
  function sortBrandCards() {
    document.querySelectorAll('.brand-group__grid').forEach((grid) => {
      const cards = Array.from(grid.querySelectorAll(':scope > .brand-card'));

      cards.sort((firstCard, secondCard) => {
        const firstName = firstCard.querySelector('.brand-card__name')?.textContent.trim() || '';
        const secondName = secondCard.querySelector('.brand-card__name')?.textContent.trim() || '';

        return firstName.localeCompare(secondName, undefined, {
          sensitivity: 'base',
          numeric: true
        });
      });

      cards.forEach((card) => grid.appendChild(card));
    });
  }

  function updateBrandIndex() {
    document.querySelectorAll('.brand-list__index-link[data-brand-target]').forEach((link) => {
      link.hidden = !document.getElementById(link.dataset.brandTarget);
    });
  }

  function updateBrandList() {
    sortBrandCards();
    updateBrandIndex();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateBrandList, { once: true });
  } else {
    updateBrandList();
  }

  document.addEventListener('shopify:section:load', updateBrandList);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coming-soon-vote"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageKey = 'coming-soon-votes-v1';

    const readVotes = () => {
      try {
        return JSON.parse(localStorage.getItem(storageKey)) || {};
      } catch (error) {
        return {};
      }
    };

    const writeVotes = (votes) => {
      try {
        localStorage.setItem(storageKey, JSON.stringify(votes));
      } catch (error) {
        return;
      }
    };

    const trackVote = (eventName, itemId, itemName) => {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, {
          item_id: itemId,
          item_name: itemName
        });
        return;
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: eventName,
        item_id: itemId,
        item_name: itemName
      });
    };

    const initializeSection = (section) => {
      if (section.dataset.voteInitialized === 'true') return;
      section.dataset.voteInitialized = 'true';

      const idleLabel = section.dataset.labelIdle;
      const activeLabel = section.dataset.labelActive;
      const addedMessage = section.dataset.messageAdded;
      const removedMessage = section.dataset.messageRemoved;
      const status = section.querySelector('[data-coming-soon-status]');
      const dialog = section.querySelector('[data-coming-soon-dialog]');
      const dialogImageContainer = section.querySelector('[data-coming-soon-dialog-image]');
      const dialogImage = document.createElement('img');
      dialogImage.className = 'coming-soon-vote__dialog-image';
      dialogImageContainer.appendChild(dialogImage);
      const closeButton = section.querySelector('[data-coming-soon-close]');

      const renderButton = (button, isActive) => {
        button.setAttribute('aria-pressed', String(isActive));
        button.querySelector('[data-coming-soon-icon]').textContent = isActive ? '✓' : '↑';
        button.querySelector('[data-coming-soon-label]').textContent = isActive ? activeLabel : idleLabel;
      };

      section.querySelectorAll('[data-coming-soon-button]').forEach((button) => {
        renderButton(button, Boolean(readVotes()[button.dataset.itemId]));

        button.addEventListener('click', () => {
          const votes = readVotes();
          const isActive = !votes[button.dataset.itemId];

          if (isActive) {
            votes[button.dataset.itemId] = true;
          } else {
            delete votes[button.dataset.itemId];
          }

          writeVotes(votes);

          const update = () => renderButton(button, isActive);
          if (document.startViewTransition) {
            document.startViewTransition(update);
          } else {
            update();
          }

          status.textContent = isActive ? addedMessage : removedMessage;
          trackVote(isActive ? 'coming_soon_vote' : 'coming_soon_unvote', button.dataset.itemId, button.dataset.itemName);
        });
      });

      section.querySelectorAll('[data-coming-soon-zoom]').forEach((button) => {
        button.addEventListener('click', () => {
          dialogImage.src = button.dataset.fullImage;
          dialogImage.alt = button.dataset.imageAlt;
          dialog.showModal();
        });
      });

      closeButton.addEventListener('click', () => dialog.close());

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      dialog.addEventListener('close', () => {
        dialogImage.src = '';
        dialogImage.alt = '';
      });
    };

    document.querySelectorAll('[data-coming-soon-section]').forEach(initializeSection);

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-coming-soon-section]');
      if (section) initializeSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
